import React from 'react'

export class CollaboratorsProvider extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      collaborators: this.obtainStoredCollaborators(),
      scanId: this.obtainStoredScan()
    }
  }

  obtainStoredCollaborators() {
    const collaboration = window.sessionStorage.getItem('collaborators');
    return collaboration ? JSON.parse(collaboration) : []
  }

  obtainStoredScan() {
    const storedScanId = window.sessionStorage.getItem('scanId')
    return storedScanId ? storedScanId : 0
  }

  render() {

    return (
      <CollaboratorsContext.Provider
        value={{
          state: this.state,
          updateCollaborators: () => {
            this.setState({
              ...this.state,
              collaborators: this.obtainStoredCollaborators()
            })
          },
          updateScan: () => {
            this.setState({
              ...this.state,
              scanId: this.obtainStoredScan()
            })
          }
        }}>
        {this.props.children}
      </CollaboratorsContext.Provider>
    )
  }
}

export const CollaboratorsContext = React.createContext()


// WEBPACK FOOTER //
// ./src/context/CollaboratorsContext.js